module.exports = __webpack_public_path__ + "img/hbase.ab197ac6.svg";